module.exports = __webpack_public_path__ + "static/media/basketball.a8a33835.jpg";